import CTAButton from "./CTAButton";

export default function HowToUseSection({ content = {}, onCheckout, canCheckout }) {
  const title = content.title || "Cara Menikmati Produk Ini";
  const items = content.items || [];
  const tip = content.tip || "";

  return (
    <section className="py-20 lg:py-28 bg-gradient-soft">
      <div className="mx-auto max-w-6xl px-5">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Mudah & Praktis</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-balance">
            {title}
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((s, i) => (
            <div
              key={i}
              className="relative rounded-3xl bg-white border border-border p-6 shadow-card"
            >
              <div className="font-display text-5xl font-bold text-[oklch(0.52_0.22_25/0.15)] leading-none">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-3 font-bold text-lg">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        {tip && (
          <div className="mt-8 mx-auto max-w-2xl rounded-2xl bg-[var(--kp-accent)]/50 border border-[oklch(0.52_0.22_25/0.2)] p-5 text-center text-sm text-foreground">
            💡 <strong>Tips:</strong> {tip}
          </div>
        )}

        <div className="mt-10 text-center">
          <CTAButton size="lg" onClick={onCheckout} disabled={!canCheckout}>
            🌺 Coba Sekarang
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
